var EPK = EPK || {};
EPK.GenericMedicines = EPK.GenericMedicines || {};
EPK.GenericMedicines.ARG = EPK.GenericMedicines.ARG || {searchUrl: '' , medicineIndex: 0};

EPK.GenericMedicines.Search = function(searchUrl,medicineIndex){
    this.searchUrl = searchUrl;
    this.medicineIndex = medicineIndex;
    this.onComposition = false;
    this.onSearch = false;
    this.eventType = 'compositionstart compositionend input propertychange keyup';
};

EPK.GenericMedicines.ARG.selectedStartDateIndex = 0;
EPK.GenericMedicines.ARG.selectedEndDateIndex = 0;


EPK.GenericMedicines.changeStartDateSelect = function(){
    console.log('EPK.GenericMedicines.changeStartDateSelect');
    $("#startdate_select option:selected").each(function () {
        var selectedIndex = $(this).attr('data-index')*1;

        EPK.GenericMedicines.ARG.selectedStartDateIndex = selectedIndex;

        $('.starttime_select').each(function(){
            if($(this).attr('data-index') == selectedIndex){
                $(this).show();
            }else{
                $(this).hide();
            }
        });

        $('.endtime_select option').each(function(){
            if($(this).attr('parent-index')*1 != selectedIndex){
                $(this).show();
            }
        });


        var selected_faster_date = false;
        $("#enddate_select option:selected").each(function () {
            var selectedEndIndex = $(this).attr('data-index') * 1;
            if (selectedEndIndex < selectedIndex) {
                selected_faster_date = true;
            }
        });

        $("#enddate_select option").each(function () {
            if($(this).attr('data-index') < selectedIndex) {
                $(this).hide();
            }else{
                if(selected_faster_date){
                    $(this).prop('selected', true);
                    selected_faster_date = false;
                    EPK.GenericMedicines.changeEndDateSelect();
                }
                $(this).show();
            }
        });
    });
};

EPK.GenericMedicines.changeEndDateSelect = function(){
    console.log("EPK.GenericMedicines.changeEndDateSelect");
    var str = "";
    $("#enddate_select option:selected").each(function () {
        var selectedIndex = $(this).attr('data-index')*1;
        EPK.GenericMedicines.ARG.selectedEndDateIndex = selectedIndex;
        $('.endtime_select').each(function(){
            if($(this).attr('data-index') == selectedIndex){
                $(this).show();
            }else{
                $(this).hide();
            }
        });
    });
};

EPK.GenericMedicines.changeStartTimeSelect = function(){
    $(this).children("option:selected").each(function(){
        var selectedDateIndex = $(this).attr('parent-index')*1;
        var selectedTimeIndex = $(this).attr('data-index')*1;
        var selected_faster_time = false;

        var query = '.endtime_select[data-index="'+selectedDateIndex+'"] option:selected';
        $(query).each(function(){
            var selectedEndIndex = $(this).attr('data-index')*1;
            if(selectedEndIndex < selectedTimeIndex){
                selected_faster_time = true;
            }
        });

        var query = '.endtime_select[data-index="'+selectedDateIndex+'"] option';
        $(query).each(function(){
            var optionIndex = $(this).attr('data-index')*1;
            var parentIndex = $(this).attr('parent-index')*1;

            if (parentIndex > selectedDateIndex){
                $(this).show();
            }else if(optionIndex > selectedTimeIndex){
                $(this).show();
            }else if(optionIndex == -1) {
                // 現在時刻よりもあとが、開始日としてしたいされた場合、
                // 初期値にセット
                if(selected_faster_time){
                    $(this).prop('selected', true);
                }
                $(this).show();
            }else {
                $(this).hide();
            }

        });

    });

};

EPK.GenericMedicines.checkRequiredInputVal = function(){
    var requiredInput = $('.required');
    var requiredCheckBox = $("input[type='checkbox']:checked");
    var requiredInputIsAllEntered = true;

    $.each(requiredInput, function(index, value){
        if($(this).val() == "" || $(this).val() == undefined ) {
            requiredInputIsAllEntered = false;
            return false;
        }
    });

    if(requiredCheckBox.length != 3 ) {
        requiredInputIsAllEntered = false;
    };

    if(requiredInputIsAllEntered){
        $(".contact-form-submit").prop("disabled",false);
    }else{
        $(".contact-form-submit").prop("disabled",true);
    }
}


$("#startdate_select").change(EPK.GenericMedicines.changeStartDateSelect).change();
$("#enddate_select").change(EPK.GenericMedicines.changeEndDateSelect).change();
$(".starttime_select").change(EPK.GenericMedicines.changeStartTimeSelect);
$('.required, form-searchBox__btnClose').on('input',function(){
    EPK.GenericMedicines.checkRequiredInputVal();
})
$('.pulldown a').on('click',function(){
    EPK.GenericMedicines.checkRequiredInputVal();
})
$('input').on('input',function(){
    $(this).removeClass("form-error");
    $(this).closest(".form-error").removeClass("form-error");
})

EPK.GenericMedicines.Search.prototype.request = function(event,phraseArg){
    var _this = this;
    var phrase = _this.katakanaToHiragana(phraseArg);

    _this.onSearch = true;
    _this.setLatestSearchPhrase(event,phrase);
    _this.showMedicineListLoading(event);

    $.ajax({
        type: "GET",
        url: this.searchUrl,
        cache: false,
        timeout: 60000,
        data: {medicine_name: phrase},
        context:_this
    }).done(function(data){
        if(data.results){
            if(data.results.length > 0){
                _this.resetSuggestion(_this.targetElement);
                $.each(data.results, function(index, value){
                    var list = $("<li>");
                    list.text(value.trn_shohin);
                    list.data('yj_code', value.trn_toroku_code);
                    list.data('kohatsu', value.trn_kouhatsu);
                    list.data('unit', value.unit_name);
                    list.data('name', value.trn_shohin);
                    list.on('click', function(event){
                        _this.selectMedicine(event);
                    });
                    _this.suggestElement.append(list);
                });
                _this.suggestElement.show();
            }else{
                _this.resetSuggestion(_this.targetElement);
                var notfound = $('<li class="notfound">ご入力されたお薬はありませんでした。</li>');
                _this.suggestElement.append(notfound);
            }
        }
        _this.onSearch = false;
    }).fail(function(){
        _this.resetSuggestion(_this.targetElement);
        _this.suggestElement.hide();
        _this.showPopupMessage();
        _this.onSearch = false;
    });
};

EPK.GenericMedicines.Search.prototype.checkSearchEvent = function (event){

    if(event.type === "keyup"){
        switch(event.keyCode){
            case 8: // keyCode 8 = Backspace
                return true;
            case 13: // keyCode 13 = Enter
                return true;
            case 46: // keyCode 46 = Delete
                return true;
            default:
                // console.log(event.keyCode);
                return false;
        }
    }
    // console.log(event.type);

    if(event.type === "compositionstart"){
        this.onComposition = true;
        return false;
    }
    if(event.type === "compositionend"){
        this.onComposition = false;
        return true;
    }

    if(this.onComposition){
        return false;
    }

    if(event.type === "blur"){
        if(this.selectionDisplayed(event) === true){
            return false;
        }
    }

    return true;
};

EPK.GenericMedicines.Search.prototype.search = function(event){

    this.targetElement = $(event.target);
    this.suggestElement = $(event.target).parent().find(".suggested-list");
    var recentSearchPhrase = this.getLatestSearchPhrase(event);
    if(this.onSearch){
        return;
    }
    if(this.checkSearchEvent(event) !== true){
        return;
    }

    var inputPhrase = this.targetElement.val().replace(/(\s|　)/g,'');
    var inputHiraganaPhrase = this.katakanaToHiragana(inputPhrase);
    this.targetElement.val(inputPhrase);
    var newSearchPhrase = inputHiraganaPhrase.substr(0, 4);

    if(newSearchPhrase.length >= 3 && newSearchPhrase !== recentSearchPhrase){
        // ４文字の検索用文字列が更新されたのでAjaxリクエスト
        this.request(event,newSearchPhrase);
        return;
    }

    if(newSearchPhrase.length < 3){
        this.resetSuggestion(this.targetElement);
        this.setLatestSearchPhrase(event,"first");
        this.targetElement.hide();
    }else{
        // ４文字以下の検索用文字列は更新されていないけど、文字列は変わっているはずなので、インクリメンタルサーチ
        // console.log("インクリメンタルサーチ");
        this.listSearch(event,inputPhrase);
    }
};

EPK.GenericMedicines.Search.prototype.listSearch = function(event,phraseArg){
    var phrase = this.hiraganaToKatagana(phraseArg);
    var regex = new RegExp(phrase);
    var suggest = $(event.target).parent().find(".suggested-list");
    suggest.show();

    suggest.find("li").each(function(){
        var $this = $(this);
        var found = $this.text().match(regex);
        $this.hide();
        if(found){
            $this.show();
        }
    });
};

EPK.GenericMedicines.Search.prototype.showMedicineListLoading = function(event){
    this.targetElement = $(event.target);
    this.suggestElement = $(event.target).parent().find(".suggested-list");

    this.resetSuggestion(this.targetElement);
    var loading = $('<li class="suggested-loading"><img src="/img/generic/img_loading.gif" alt="loading"></li>');
    this.suggestElement.append(loading);
    this.suggestElement.show();
};

EPK.GenericMedicines.Search.prototype.setLatestSearchPhrase = function(event,phrase){
    var element = $(event.target);
    return element.parent().find(".medicine_name_key").val(phrase);
};


EPK.GenericMedicines.Search.prototype.getLatestSearchPhrase = function(event){
    var element = $(event.target);
    return element.parent().find(".medicine_name_key").val();
};

EPK.GenericMedicines.Search.prototype.selectionDisplayed = function(event){

    var suggestList = $(event.target).parent().find(".suggested-list");
    var size = suggestList.find("li").size();
    var visibility = suggestList.is(":visible");
    var notfound = false;

    if(size === 0){
        return false;
    }

    if(visibility === false){
        return false;
    }

    suggestList.find("li").each(function(){
        var $this = $(this);
        if($this.hasClass("notfound")){
            notfound = true;
            return false;
        }
    });
    return true;
};

EPK.GenericMedicines.Search.prototype.selectMedicine = function(event){

    var element = $(event.target);
    var rootElement = element.closest('.ph-material-body');
    var medicineNameElement = rootElement.find(".medicine_name");
    var medicineYjCode = rootElement.find(".medicine_yj_code");
    var medicineUnit = rootElement.find(".medicine_unit");
    var medicineNumberUnit = rootElement.find(".medicine_number_unit");

    this.unbindSearchRequest(medicineNameElement);
    medicineNameElement.val(element.data("name"));
    this.bindSearchRequest(medicineNameElement);

    medicineYjCode.val(element.data("yj_code"));
    medicineUnit.val(element.data("unit"));
    medicineNumberUnit.text(element.data("unit"));

    element.parent().hide();
    element.parent().find("li").show();
};

EPK.GenericMedicines.Search.prototype.deleteInput = function(event){
    var element = $(event.target);
    element.parent().remove();
    this.deleteButtonToggle();
};

EPK.GenericMedicines.Search.prototype.deleteButtonToggle = function(){
    var boxes = $(".form-searchBox").size();
    if(boxes <= 1){
        $(".form-searchBox__btnClose").hide();
    } else {
        $(".form-searchBox__btnClose").show();
    }
};

EPK.GenericMedicines.Search.prototype.showNewInput = function(key){
    var Search = this;
    var medicine = {key: key};
    var rendered = $("#medicineSearchBox").render(medicine);
    var elem = $(rendered);
    $(".selected_area").append(elem);

    Search.bindSearchRequest(elem.find('.medicine_name'));
    elem.find(".form-searchBox__btnClose").on('click', function(event){
        Search.deleteInput(event);
    });
    Search.bindNumericChange(elem.find('.medicine_number'));

    this.deleteButtonToggle();
    elem.find(".input-suggested_deleteBtn").on('click', function(event){
        Search.bindResetMedicine($(event.target));
    });
    elem.find(".input_text_deleteBtn").on('click', function(event){
        Search.bindResetMedicine($(event.target));
    });
};

EPK.GenericMedicines.Search.prototype.resetSuggestion = function(target){
    this.targetElement = $(target).parent().find(".suggested-list");
    this.targetElement.find("li").remove();
};

EPK.GenericMedicines.Search.prototype.resetMedicine = function(event){
    var element = $(event.target);
    var rootElement = element.parent().parent().parent();
    var medicineNameElement = rootElement.find(".medicine_name");
    var medicineNumberKey = rootElement.find(".medicine_name_key");
    var medicineYjCode = rootElement.find(".medicine_yj_code");
    var medicineUnit = rootElement.find(".medicine_unit");
    var medicineNumber = rootElement.find(".medicine_number");
    var medicineNumberUnit = rootElement.find(".medicine_number_unit");
    var suggestedList = rootElement.find(".suggested-list");

    medicineNumberKey.val("");

    this.unbindSearchRequest(medicineNameElement);
    medicineNameElement.val("");
    this.bindSearchRequest(medicineNameElement);

    medicineYjCode.val("");
    medicineUnit.val("");
    medicineNumber.val("");
    medicineNumberUnit.text("錠");

    this.resetSuggestion(suggestedList);
};

EPK.GenericMedicines.Search.prototype.bindResetMedicine = function(element){
    var _this = this;
    $(element).on('click', function(event){
        _this.resetMedicine(event);
        return false;
    });
};

EPK.GenericMedicines.Search.prototype.showPopupMessage = function(){
    var $suggestedTimeout = $(".suggestedTimeout");
    var $suggestedList = $(".suggested-list");

    $suggestedTimeout.addClass("is-show");
    $suggestedTimeout.show();
    $suggestedList.hide();
};

EPK.GenericMedicines.Search.prototype.hidePopupMessage = function(){
    var $suggestedTimeout = $(".suggestedTimeout");
    var $suggestedList = $(".suggested-list");

    $suggestedTimeout.removeClass("is-show");
    $suggestedTimeout.hide();
    $suggestedList.hide();
};

EPK.GenericMedicines.Search.prototype.bindSearchRequest = function(element){
    var $element = $(element);
    var _this = this;
    $element.on(this.eventType, function(event){
        _this.search(event);
    });
};

EPK.GenericMedicines.Search.prototype.unbindSearchRequest = function(element){
    $(element).off(this.eventType);
};

EPK.GenericMedicines.Search.prototype.bindNumericChange = function(element){
    var $element = $(element);
    var _this = this;
    $element.blur(function(event){
        _this.charactersChange(event.target);
    });
};



EPK.GenericMedicines.Search.prototype.initialize = function(){
    // 入力欄追加ボタン
    var $showInputMedicineName = $("#show_input_medicine_name");
    // 薬品名 Input
    var $medicineName = $('.medicine_name');
    var $inputSuggestedDeleteBtn = $('.input-suggested_deleteBtn');
    var $formSearchBoxbtnClose = $(".form-searchBox__btnClose");
    var $timeoutClose = $("#timeoutClose");
    var $suggestedList = $(".suggested-list");
    var $showGenericSearchModal = $("#show-generic-search-modal");
    var $genericSearchModal = $("#generic-search-modal");
    var $jsCharactersChange = $(".js-characters-change");

    var _this = this;

    $showInputMedicineName.on('click', function(){
        _this.medicineIndex += 1;
        _this.showNewInput(_this.medicineIndex);
        return false;
    });

    this.bindSearchRequest($medicineName);
    this.bindResetMedicine($inputSuggestedDeleteBtn);

    $formSearchBoxbtnClose.on('click', function(event){
        _this.deleteInput(event);
    });

    this.deleteButtonToggle();

    $timeoutClose.on("click", function(){
        _this.hidePopupMessage();
    });

    $suggestedList.removeClass("is-show");

    $showGenericSearchModal.on('click', function(){
        $genericSearchModal.show();
    });

    $jsCharactersChange.blur(function(event){
        _this.charactersChange(event.target);
    });
};

/** カタカナをひらがなに変換する関数
 * @param {String} src - カタカナ
 * @returns {String} - ひらがな
 */
EPK.GenericMedicines.Search.prototype.katakanaToHiragana = function (src){
    return src.replace(/[\u30a1-\u30f6]/g, function(match){
        var chr = match.charCodeAt(0) - 0x60;
        return String.fromCharCode(chr);
    });
};

/** ひらがなをカタカナに変換する関数
 * @param {String} src - ひらがな
 * @returns {String} - カタカナ
 */
EPK.GenericMedicines.Search.prototype.hiraganaToKatagana = function (src){
    return src.replace(/[\u3041-\u3096]/g, function(match){
        var chr = match.charCodeAt(0) + 0x60;
        return String.fromCharCode(chr);
    });
};

EPK.GenericMedicines.Search.prototype.charactersChange = function(elementArg){
    var element = $(elementArg);
    var val = element.val();
    var han = val.replace(/[Ａ-Ｚａ-ｚ０-９]/g,function(s){return String.fromCharCode(s.charCodeAt(0)-0xFEE0)});

    if(val.match(/[Ａ-Ｚａ-ｚ０-９]/g)){
        element.val(han);
    }
};

$(function(){
    var Search = new EPK.GenericMedicines.Search(
        EPK.GenericMedicines.ARG.searchUrl,
        EPK.GenericMedicines.ARG.medicineIndex
    );
    Search.initialize();

    // // ページ内スクロール
    $('.scrollTop').on('click', function(){
        var speed = 400;
        var href = $(this).attr('href');
        var target = $(href === '#' || href === '' ? 'html' : href);
        var position = target.offset().top - 100;
        $('body,html').animate({scrollTop: position}, speed, 'swing');
        return false;
    });

    var $applybtn = $("#applybtn");
    var $window = $(window);
    var $document = $(document);
    var $nav = $('#nav');

    $applybtn.hide();

    $window.on("scroll", function(){

        if ($(this).scrollTop() > 340){
            $applybtn.slideDown("fast");
        } else {
            $applybtn.slideUp("fast");
        }

        var scrollHeight = $document.height();
        var scrollPosition = $window.height() + $window.scrollTop();
        var footHeight = $("footer").innerHeight();

        if(scrollHeight - scrollPosition <= footHeight){
            $applybtn.css({
                "position": 'absolute',
                "bottom": footHeight
            });
        } else {
            $applybtn.css({
                "position": 'fixed',
                "bottom": "0px"
            });
        }
    });

    if($nav.offset()){
        var navPos = $nav.offset().top;
        // ロード or スクロールされると実行
        $window.on('load scroll', function(){
            // ヘッダーの高さ分(80px)スクロールするとfixedクラスを追加
            if($window.scrollTop() > navPos){
                $nav.addClass('fixed');
            } else {
                // 80px以下だとfixedクラスを削除
                $nav.removeClass('fixed');
            }
        });
    }

    $('.input_text_deleteBtn').on('click', function(){
        $(this).parent().find("input").val('');
    });

    $('.drugsubmit').on('click', function() {
        $(this).parents('form').attr('action', $(this).data('action'));
        $(this).parents('form').attr('target', '_blank');
        $(this).parents('form').submit();
    });

    // $('#countact-form').submit(function() {
    //     console.log("aaaaaaaaaaa")
    // });

    $('.contact-form-submit').on('click', function(){
        EPK.GenericMedicines.ARG.selectedEndDateIndex;
        $('.starttime_select').each(function(){
            if($(this).attr('data-index')*1 != EPK.GenericMedicines.ARG.selectedStartDateIndex){
                $(this).remove();
            }
        });

        $('.endtime_select').each(function(){
            if($(this).attr('data-index')*1 != EPK.GenericMedicines.ARG.selectedEndDateIndex){
                $(this).remove();
            }
        });

        var $form = $('#countact-form');
        $form.submit();
    })

    if($("#countact-form").length !=0){
        EPK.GenericMedicines.checkRequiredInputVal();
    }

});

$(function () {
    var EPK = EPK || {};
    EPK.popupArray = EPK.callcenterPopupArray || [];
    EPK.popupArray.push('#modal-btn-1');

    EPK.accordionTabsArray = EPK.accordionTabsArray || [];
    EPK.accordionTabsArray.push("expand-menu");

    if (EPK.popupArray instanceof Array){
        EPK.popupArray.forEach(function(btnId){
            $(btnId).magnificPopup({
                "type": 'inline',
                "preloader": false,
                'showCloseBtn': false,
                'removalDelay': 400,
                'mainClass': 'mfp-fade',
                'overflowY': 'scroll'
            });
            $('.btn-closeModal').click(
                function(e){
                    e.preventDefault();
                    $.magnificPopup.close();
                }
            );
        });
       
    }
});
